import React from "react";
import { Tabs, Tab } from "@mui/material";

interface CarTabsProps {
  value: number;
  onChange: (
    _e: React.SyntheticEvent<Element, Event>,
    newValue: number
  ) => void;
  tabLabels: string[];
}

const CarTabs = ({ value, onChange, tabLabels }: CarTabsProps) => {
  return (
    <div className="mb-4 border-b border-gray-200">
      <Tabs
        value={value}
        onChange={onChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabLabels.map((label, index) => (
          <Tab key={index} label={label} sx={{ fontWeight: "bold" }} />
        ))}
      </Tabs>
    </div>
  );
};

export default CarTabs;
